import * as pointColors from '../../../assets/styles/variables/colors.scss'

export default {
    input:{
        border: `0.5px solid ${pointColors.fillStroke200}`,
    }
}